<template>
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-icon="BellOutlined"
	>
		<path
			d="M10 3.176v-.26c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v.26c3.45.917 6 4.15 6 7.998v6.364h1a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1v-6.364c0-3.848 2.55-7.081 6-7.998ZM6 17.538h12v-6.361c0-3.458-2.686-6.261-6-6.261s-6 2.803-6 6.26v6.362Zm2.75 4.5a1 1 0 0 1 1-1h4.5a1 1 0 0 1 0 2h-4.5a1 1 0 0 1-1-1Z"
			fill="currentColor"
		></path>
	</svg>
</template>
